import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Clientes extends Component {
 constructor(props){
     super(props);

     this.state = {
         clientes: []
     }

fetch('https://ebenlovequickpc.com/API/clientes.php')
    .then((response => response.json()))
    .then((json) => {
        this.setState({
            clientes: json
        });
    });
 }

 componentWillUpdate(){
    
 }

  render() {
    return (
        <div className="w3-container">
            <h5>Clientes</h5>
            <ul className="w3-ul w3-card-4 w3-white">
                { this.state.clientes.map((v, i) => {
                    return (
                    <li className="w3-padding-16 w3-display-container" key={v.CODIGO_USER}>
                        <img src="https://www.w3schools.com/w3images/avatar2.png" alt='' className="w3-left w3-circle w3-margin-right" style={{width:'35px'}} />
                        <span className="w3-xlarge">{v.NOMBRE} {v.APELLIDOS}</span>
                        <Link to={`/clientes/${v.CODIGO_USER}`} className="w3-button w3-border w3-display-right w3-round-large" style={{marginRight: '7px'}}>Ver</Link>
                    </li>)
                }) }
                
            </ul>
      </div>
    );
  }
}

export default Clientes;


// WEBPACK FOOTER //
// ./src/Clientes/Clientes.js